import React, { Component } from 'react';
import EventForm from '../forms/EventForm';
let bcrypt = require('bcryptjs');

class FormWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: ''
    }
    this.props.getEvents();
  }

  handleSubmit = (e) => {
    e.preventDefault();

    let user = { ...this.props.user };
    let event = { ...this.props.event };

    this.checkUserFieldsTouched('firstname', user);
    this.checkUserFieldsTouched('lastname', user);
    this.checkUserFieldsTouched('email', user);
    this.checkEventFieldsTouched('organization_name', event);
    this.checkEventFieldsTouched('phone_number', event);
    this.checkEventFieldsTouched('postal_code', event);

    if (this.form.state.user.password !== undefined) {
      user.password_digest = bcrypt.hashSync(this.form.state.user.password, 8);
    }

    if (this.validateFormState()) {
      this.props.updateUser(user);
      this.props.updateEvent(event);
      window.scrollTo(0,0);
      this.setState({
        error: ''
      })
    }
    else {
      this.setState({
        error: 'Please correct the errors above before continuing'
      })
    }
  }

  checkUserFieldsTouched = (prop, user) => {
    if (this.form.state.user[prop] !== '') {
      user[prop] = this.form.state.user[prop];
    }
  }
  checkEventFieldsTouched = (prop, event) => {
    if (this.form.state.event[prop] !== '') {
      event[prop] = this.form.state.event[prop];
    }
  }

  validateFormState = () => {
    let warnings = this.form.state.warnings;

    if (Object.keys(warnings).length === 0) {
      return true;
    }
    for (let warning in warnings) {
      if (warnings[warning] !== '') { return false; }
    }
    return true;
  }

  render() {
    return (
      <EventForm ref={(form) => {this.form = form}} event={this.state.event} user={this.props.currentUser} handleSubmit={this.handleSubmit} alert={this.props.alertMessage} clearAlert={this.props.clearAlert} />
    )
  }
}

export default FormWrapper
